import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import { adminHttp } from "~/Admin/services/http";
import Pagination from "react-js-pagination";
import { Form } from "react-bootstrap";
import { toggleArray } from "~/services/helpers";
import AdminReportFilters from '../AdminReportFilters/AdminReportFilters';

const AdminReportRegList = ({ match, event, ...props }) => {

    const [response, setResponse] = useState({});
    const [selected, setSelected] = useState([]);

    const defaultFilters = {
        wave_id: '',
        name: '',
        package_id: '',
        rsvp_status: '',
    };

    const [filter, setFilter] = useState(defaultFilters);
    const [waves, setWaves] = useState([]);
    const [packages, setPackages] = useState([]);
    const [rsvpStatuses, setRsvpStatuses] = useState([
        'pending', 'confirmed', 'declined'
    ]);

    const endpoint = '/events/' + event.id + '/report/registration';

    const loadData = (page = 1) => {
        adminHttp
            .get(endpoint + '?' + new URLSearchParams({ ...filter, page }).toString())
            .then(res => {
                setResponse(res.data);
            });
    };

    const loadWaves = () => {
        adminHttp
            .get('/events/' + event.id + '/waves',)
            .then(res => setWaves(res.data));
    };

    const loadPackages = () => {
        adminHttp
            .get('/events/' + event.id + '/packages',)
            .then(res => setPackages(res.data));
    };

    useEffect(loadWaves, []);
    useEffect(loadPackages, []);
    useEffect(loadData, [filter, event]);

    const handleClearFilter = () => {
        setFilter(defaultFilters);
    };

    const handleFilter = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let filterData = { ...filter, [name]: value };

        setFilter(filterData);
    };

    const handleSelectedChange = (id) => {
        setSelected(toggleArray(selected, id));
    };

    const downloadAllUrl = `/admin-api${endpoint}/download-all`;
    const downloadUrl = '/admin-api' + endpoint + '/download?' + new URLSearchParams(filter).toString();
    const downloadSelectedUrl = '/admin-api' + endpoint + '/download?' + new URLSearchParams({
        'ids[]': selected
    }).toString();

    return (

        <div className="admin-registration-report">
            <div className="row mb-2">
                <div className="col-12 text-right">
                    <a href={downloadAllUrl} target="_blank" className="text-primary">
                        Download all (.csv)
                    </a>
                    <span> | </span>
                    <a href={downloadUrl} target="_blank" className="text-primary">
                        Download (.csv)
                    </a>
                    {selected.length > 0 && (
                        <>
                            <span> | </span>
                            <a href={downloadSelectedUrl} target="_blank" className="text-primary">
                                Download selected: {selected.length} (.csv)
                            </a>
                        </>
                    )}
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="card shadow-sm bg-white reports-filter">
                        <AdminReportFilters
                            filter={filter}
                            waves={waves}
                            packages={packages}
                            rsvpStatuses={rsvpStatuses}
                            handleFilter={handleFilter}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="card shadow-sm bg-white mt-3">

                        <div className="card-body">

                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">ID</th>
                                        <th scope="col">Guest Name</th>
                                        <th scope="col">Guest Type</th>
                                        <th scope="col">Wave</th>
                                        <th scope="col">Package</th>
                                        <th scope="col">NEOM Department</th>
                                        <th scope="col">RSVP Status</th>
                                        <th scope="col">Registration Status</th>
                                        <th scope="col">% Complete</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {response.data?.map(r => (
                                        <tr key={r.id}>
                                            <td scope="row">
                                                <Form.Check
                                                    onChange={e => handleSelectedChange(r.id)}
                                                    key={r.id}
                                                    inline
                                                    type="checkbox"
                                                    id={'upload-' + r.id}
                                                    value={r.id}
                                                    checked={selected.indexOf(r.id) >= 0}
                                                />
                                            </td>
                                            <th scope="col">{r.id}</th>
                                            <td scope="col">{r.guest_name}</td>
                                            <td scope="col">{r.guest_type || '-'}</td>
                                            <td scope="col">{r.wave}</td>
                                            <td scope="col">{r.package}</td>
                                            <td scope="col">{r?.neom_department?.name || '-'}</td>
                                            <td scope="col">{r.rsvp_status}</td>
                                            <td scope="col">{r.registration_status}</td>
                                            <td scope="col">{r.progress}%</td>
                                        </tr>
                                    ))}
                                </tbody>

                            </table>

                            {response?.meta && response.meta.per_page < response.meta.total && (
                                <Pagination
                                    activePage={response.meta.current_page}
                                    itemsCountPerPage={response.meta.per_page}
                                    totalItemsCount={response.meta.total}
                                    pageRangeDisplayed={5}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    onChange={loadData}
                                />
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminReportRegList);
